export interface RegisterSystemBatchMenuRequest {
  name: string
  menus: {
    key: string
    value: string
  }[]
}

export function RegisterSystemBatchMenuRequestToJSON(
  value: RegisterSystemBatchMenuRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    menus:
      value.menus.length > 0
        ? value.menus.map(menu => {
            return {
              key: menu.key !== '' ? menu.key : '',
              value: menu.value !== '' ? menu.value : ''
            }
          })
        : undefined
  }
}
